export async function matcherCompletionSource(context) {
  const match = context.matchBefore(/\[#[\w-]*/)
  if (!match) return null
  if (match.from === match.to && !context.explicit) return null

  const prefix = "[#"
  // match.text contains the full matched string
  const query = match.text.slice(prefix.length)

  try {
    const res = await fetch(`/api/v1/autocomplete/matchers.json?query=${encodeURIComponent(query)}`, {
      headers: {
        "content-type": "application/json"
      }
    })
    const json = await res.json()

    return {
      from: match.from + prefix.length,
      options: json["matchers"].map(m => ({
        label: m.label,
        detail: `${m.display}`,
        boost: m.boost,
        type: "matcher"
      }))
    }
  } catch(err) {
    if (err.name !== "AbortError") throw err
  }
}
